import { DatePicker } from '../NarusMaterial/DatePicker'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const DateInputField = DatePicker
export const DateInput = makeAutobindedInput(
  makeValidatedInput(DateInputField)
)
